import { useState } from "react";
import { Outlet } from "react-router-dom";
import HeaderDashboard from "./header/HeaderDashboard";
import Sidebar from "./sidebar/Sidebar";

export default function LayoutDashboard({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="lg:flex">
        <Sidebar open={open} onClose={() => setOpen(false)} />

        <div className="flex-1">
          <HeaderDashboard onMenuClick={() => setOpen(true)} />
          <main className="p-4">{children}</main>
          <Outlet />
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
}
